import { motion } from 'framer-motion';
import Container from './Container';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';
import { positioning } from '@/lib/content';

export default function PositioningStrip() {
  return (
    <section aria-label="Positioning" className="border-y border-ink/10 bg-paper-50">
      <Container>
        <motion.ul
          variants={stagger(0, 0.08)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 divide-ink/10 sm:grid-cols-2 md:grid-cols-4 md:divide-x"
        >
          {positioning.map((item, idx) => (
            <motion.li
              key={item}
              variants={fadeUp}
              className="flex items-center gap-4 py-6 md:px-8 md:py-7"
            >
              <span className="font-mono text-xs text-ink/40">
                0{idx + 1}
              </span>
              <span className="text-[15px] font-medium leading-snug text-ink/85">
                {item}
              </span>
            </motion.li>
          ))}
        </motion.ul>
      </Container>
    </section>
  );
}
